import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideNzIcons } from './icons-provider';
import { fr_FR, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import fr from '@angular/common/locales/fr';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { TranslationService } from './services/translation.service';
import { authInterceptor } from './interceptors/auth.interceptor';
import { offlineInterceptor } from './interceptors/offline.interceptor';
import { provideServiceWorker } from '@angular/service-worker';

registerLocaleData(fr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideNzIcons(),
    provideNzI18n(fr_FR),
    // `NzModalService` lives in `NzModalModule`. Standalone components that
    // only import the module in their own `imports[]` make it available
    // locally, but our shared `ConfirmationModalService` is providedIn:'root'
    // — it resolves dependencies from the ROOT injector, not the component's.
    // Promoting the module to bootstrap-level providers fixes the NG0201
    // "No provider for _NzModalService" raised by the shared service.
    importProvidersFrom(FormsModule, NzModalModule),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, offlineInterceptor])),
    TranslationService,
    // `SessionLockService` ticks every second, so the app never reaches zone
    // stability — without the :30000 timeout the worker would never register.
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
